export default {
  APP_VERSION: "1.0.1",
  APP_NAME: "yoda-reports",
  API_URL: process.env.VUE_APP_DEV_API_URL,
  S3_URL: process.env.VUE_APP_S3_URL,
};
